import { render, staticRenderFns } from "./GDescriptionModal.vue?vue&type=template&id=79f5b98c&scoped=true&"
import script from "./GDescriptionModal.vue?vue&type=script&lang=ts&"
export * from "./GDescriptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./GDescriptionModal.vue?vue&type=style&index=0&id=79f5b98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5b98c",
  null
  
)

export default component.exports